import { useMediaQuery } from 'src/lib/use-media-query'
import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

const BREAKPOINT_RULES: Record<string, string[]> = {
    desktop: ['GANHE'],
    small: ['RODA', 'GANHE'],
}

export const TextHeaderPt = () => {
    const isDesktop = useMediaQuery('(min-width: 768px)')

    let breakAfterWords = BREAKPOINT_RULES.small

    if (isDesktop) {
        breakAfterWords = BREAKPOINT_RULES.desktop
    }

    return (
        <HighlightedText
            text="GIRE A RODA E GANHE GIROS GRÁTIS"
            highlights={[{ word: 'GIROS' }, { word: 'GRÁTIS' }]}
            breakAfterWords={breakAfterWords}
            className={styles.text_header}
        />
    )
}
